





















import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator'

@Component

export default class ComponentUploadDocumento extends Vue {
  $refs!: { upload: any }
  @Prop({ required: true }) inputId: string
  @Prop({ required: true, default: true }) showForm: boolean
  @Prop({ required: false }) accept: string
  @Prop({ default: 'Carregar' }) title: string
  model: any[] = []

  @Emit('inputFile')
  inputFile(file) { }
}
